<template>
  <div v-for="item in items" :key="item.listingId">
    <BaseItem :image="item.image" :label="item.title" />
  </div>
</template>

<script setup lang="ts">
import BaseItem from '../BaseItem/BaseItem.vue'

defineProps<{
  items: Array<{
    listingId: number
    image: string
    title: string
    quantity: number
  }>
}>()
</script>
